module.exports = __webpack_public_path__ + "./fonts/lato-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-regular-webfont.woff
// module id = 23
// module chunks = 0